import React, { useState } from 'react';
import './Reasons.css';

const Reasons = () => {
  // --- ❤️ EDIT THESE 25 REASONS ❤️ ---
  const reasons = [
    "Your smile lights up my entire world.",
    "You make the best Tea in the morning.",
    "You always know how to make me laugh when I'm stressed.",
    "The way you care for our family.",
    "Your adventurous spirit.",
    "You are my best friend.",
    "Your hugs are my favorite place to be.",
    "You are incredibly smart and driven.",
    "The way you dance when no one is watching.",
    "You support my dreams no matter what.",
    "Your cooking is better than any restaurant.",
    "You are beautiful, inside and out.",
    "The way your nose crinkles when you laugh.",
    "You are the most thoughtful person I know.",
    "We can sit in silence and still have the best time.",
    "You challenge me to be a better person.",
    "Your kindness to strangers.",
    "The way you look at me.",
    "You remember the small details.",
    "You are the strongest woman I know.",
    "Your laugh is my favorite sound.",
    "We have the best inside jokes.",
    "You make a house feel like a home.",
    "I can trust you with my life.",
    "I simply cannot imagine my life without you."
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState('next'); // For animation

  const nextReason = () => {
    setDirection('next');
    if (currentIndex < reasons.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const prevReason = () => {
    setDirection('prev');
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  return (
    <div className="reasons-container">
      <div className="reasons-wrapper">
        <h1 className="reasons-header">25 Reasons I Love You</h1>
        
        {/* The Card */}
        <div key={currentIndex} className={`reason-card fade-${direction}`}>
          <div className="card-number">Reason #{currentIndex + 1}</div>
          <p className="reason-text">"{reasons[currentIndex]}"</p>
          <div className="heart-icon">❤️</div>
        </div>

        {/* Navigation Controls */}
        <div className="controls">
          <button 
            onClick={prevReason} 
            disabled={currentIndex === 0}
            className="nav-btn"
          >
            ← Previous
          </button>
          
          <div className="progress-dots">
            {/* Simple progress indicator */}
            {currentIndex + 1} / 25
          </div>

          <button 
            onClick={nextReason} 
            disabled={currentIndex === reasons.length - 1}
            className="nav-btn"
          >
            Next →
          </button>
        </div>

        {currentIndex === 24 && (
          <p className="final-note">...and a million more.</p>
        )}
      </div>
    </div>
  );
};

export default Reasons;